import React from 'react';
import useSWR from 'swr';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import PageHeader from '@/components/PageHeader';
import { Select } from '@/components/purchasing/LineEditor';
import { Loading, ReadinessGate } from '@/components/common/F1States';
import { useSchemaReady } from '@/lib/schemaReady';
import DrawingRegister from '@/components/portal/DrawingRegister';
import * as P from '@/lib/portal/service';

// Site team view: fast, mobile-first register that defaults to current authorised construction drawings.
export default function SiteDrawingsPage() {
  const { organisationId } = useAuth(); const [sp, setSp] = useSearchParams();
  const readiness = useSchemaReady(organisationId && 'portal', P.READINESS);
  const projects = useSWR(readiness.state === 'ready' ? 'portal-projects' : null, P.myProjects);
  const projectId = sp.get('project') || projects.data?.[0]?.id;
  const current = (projects.data || []).find((p) => p.id === projectId);
  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto space-y-4" data-testid="site-drawings-page">
      <PageHeader title="Drawings" subtitle="Current authorised construction drawings first. Superseded revisions stay available for record but are marked DO NOT USE." />
      {readiness.state !== 'ready' ? <ReadinessGate readiness={readiness} module="Drawing register" migration="cp1_portal_migration.sql" testId="drawings-migration-pending" /> : projects.isLoading ? <Loading /> : <>
        <Select testId="site-project" className="!w-full md:!w-96" blank="Select a project" value={projectId || ''} onChange={(v) => setSp({ project: v })} options={(projects.data || []).map((p) => [p.id, `${p.project_code} — ${p.name}`])} />
        {projectId && <DrawingRegister projectId={projectId} myRole={current?.my_role} mode="site" />}
      </>}
    </div>
  );
}
